// IP Info API services

const IP_INFO_API_URL = "https://yoalnrn4pg.execute-api.us-east-1.amazonaws.com/prod/ipinfo";

// Fetch user's IP and location information
export const fetchIpInfoService = async () => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort("Request timed out after 10s"), 10000); // 10 second timeout

    const response = await fetch(IP_INFO_API_URL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.warn("IP info request timed out or was aborted.");
      return null;
    }
    console.error("Error fetching IP info:", error);
    throw error;
  }
};
